<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-08-09 09:21:48
 * @LastEditors: sjq
 * @LastEditTime: 2024-05-23 15:27:08
 -->
<template>
  <div>
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header
      :title="title"
      :action-name="isEdit ? 'delete' : null"
      :action-confirm="{
        message: '是否删除该地址'
      }"
      @action="removeAddresss"
    />
    <!-- 表单视图：地址（收货人姓名、手机号、所在地区、详情） -->
    <form-entity :model="address" :rules="rules" class="form-edit">
      <form-field
        prop="contactName"
        :default-focus="true"
        :options="{ label: '收货人', placeholder: '收货人姓名', type: 'text', required: true }"
      />
      <form-field
        prop="contactNo"
        :options="{ label: '手机号码', placeholder: '收货人手机号码', type: 'tel', format: 'phone', required: true }"
      />
      <form-field
        prop="addressArea"
        :options="{
          label: '所在地区',
          placeholder: '收货人所在地区',
          type: 'selectAddress',
          format: 'area',
          required: true
        }"
      />
      <form-field
        prop="addressDetail"
        :options="{ label: '详细地址', placeholder: '填写详细地址', type: 'textarea', required: true }"
      />
      <form-field prop="defaultMark" :options="{ label: '设置默认地址', type: 'switch' }" />
      <div class="btn">
        <form-submit type="primary" ref="submitButton" size="small" text="保存" @submit="saveAddress" />
      </div>
    </form-entity>
  </div>
</template>

<script>
import { MessageBox } from 'mint-ui'
import Body from '@/mixins/body'
import { getSign } from '@/utils/auth'
import { addressService } from '@/api'
import { appUser } from '@/utils'

const componentName = 'AddressPush'
export default {
  name: componentName,
  mixins: [Body],
  data() {
    return {
      rules: {},
      action: { name: '' }, // 操作的名称
      oldSign: '', // 比较编辑的信息
      newSign: '',
      address: {
        contactName: '',
        contactNo: '',
        addressArea: '',
        addressDetail: '',
        defaultMark: ''
      },
      addressId: ''
    }
  },
  computed: {
    isEdit() {
      return this.addressId > 0
    },
    title() {
      return this.isEdit ? '修改地址' : '新增地址'
    }
  },
  created() {
    this.addressId = this.$route.query.addressId
    console.log(this.addressId, 'this.addressId')
    if (this.addressId > 0) {
      this.getDetail()
    } else {
      this.address = {
        contactName: '',
        contactNo: '',
        addressArea: '',
        addressDetail: '',
        defaultMark: ''
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave', to, from, next)
    const { contactName, contactNo, addressArea, addressDetail } = this.address
    if (
      contactName === undefined &&
      contactNo === undefined &&
      addressArea === undefined &&
      addressDetail === undefined
    ) {
      next()
      return
    }
    const { name } = this.action
    // 编辑时友好提醒，添加前也提醒，点击添加后可以跳过
    if (name !== '' && name !== 'edit') {
      next()
      return
    }
    // 用户点击了保存按钮，跳转路由不该弹出是否保存弹框
    if (this.oldSign === this.newSign) {
      next()
      return
    }
    // 提示：是否保存本次编辑内容
    this.newSign = this.getFieldSign()
    if (this.oldSign !== this.newSign) {
      const saveAddress = this.$refs.submitButton.submit
      const confirm = {
        message: {
          title: '',
          message: '是否保存本次修改的信息？',
          showCancelButton: true,
          confirmButtonText: '保存',
          cancelButtonText: '不保存'
        },
        confirm: () => {
          next(false)
          saveAddress()
        },
        cancel: () => {
          next()
        }
      }
      MessageBox(confirm.message).then(action => confirm[action].call())
    } else {
      next()
    }
  },
  methods: {
    getFieldSign() {
      const { contactName, contactNo, addressArea, addressDetail } = this.address
      return getSign({ contactName, contactNo, addressArea, addressDetail })
    },
    // 更新和清空模型
    getDetail() {
      addressService
        .detail({
          id: this.addressId
        })
        .then(res => {
          this.address = res
        })
    },
    // 提交
    saveAddress() {
      this.action.name = this.isEdit ? 'edit' : 'add'
      // 是否设为默认地址
      const { address } = this
      address.defaultMark = address.defaultMark || 0
      address.areaCode = '86'
      address.createTime = ''
      address.updateTime = ''
      address.mergeAreaDetail = ''

      // 提示：是否保存本次编辑内容
      addressService.save({ ...address, defaultMark: address.defaultMark * 1, ...address.addressOption }).then(res => {
        if (this.$route.query.type === 'default') {
          let addressChecked = JSON.parse(localStorage.getItem('addressChecked')) || {}
          addressChecked[appUser.userId] = res
          localStorage.setItem('addressChecked', JSON.stringify(addressChecked))
        }
        if (this.addressId) sessionStorage.setItem('checkedAddressId', this.addressId)

        this.$router.back()
      })
    },
    removeAddresss() {
      this.action.name = 'delete'
      addressService.del({ id: this.addressId }).then(res => {
        this.$router.back()
      })
    }
  }
}
</script>
<style>
.form-edit input {
  -webkit-user-select: text;
  -user-select: text;
}
</style>
<style lang="scss" scoped>
.btn {
  width: 100%;
  position: fixed;
  bottom: 0;
}
</style>
